import script from "./UserPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPayment.vue?vue&type=script&setup=true&lang=js"

import "./UserPayment.vue?vue&type=style&index=0&id=7bb82fcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb82fcc"]])

export default __exports__